// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "a.dropdown-item-has-icon[data-v-1dabf730] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\nspan.dropdown-item-text[data-v-1dabf730] {\n  padding-left: 5px;\n}\n.table-max-width[data-v-1dabf730] {\n  max-width: 30rem;\n}\n.unread-messages-section[data-v-1dabf730] {\n  border: 1px solid var(--border-color);\n  padding: 20px;\n}", ""]);
// Exports
module.exports = exports;
